import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import AppHeader from "../common/AppHeader";
import Home from "../home/Home";
import Login from "../user/login/Login";
import Signup from "../user/signup/Signup";
import Profile from "../user/profile/Profile";
import FpSendEmailDone from "../user/fp_send_email_done/FpSendEmailDone";
import OAuth2RedirectHandler from "../user/oauth2/OAuth2RedirectHandler";
import NotFound from "../common/NotFound";
import LoadingIndicator from "../common/LoadingIndicator";
import { getClientInfo, getCurrentUser } from "../util/APIUtils";
import { ACCESS_TOKEN, CLIENT } from "../constants";
import Alert from "react-s-alert";
import "react-s-alert/dist/s-alert-default.css";
import "react-s-alert/dist/s-alert-css-effects/slide.css";
import "./App.css";
import RegistrationSuccess from "../user/registration_success/RegistrationSuccess";
import Verify from "../user/verify/Verify";
import PrivateRoute from "../common/PrivateRoute";
import { getUrlParameter } from "../util/DataUtils";
import ResetPassword from "../user/reset_password/ResetPassword";
import ForgotPassword from "../user/forgot_password/ForgotPassword";
import ResendVerifyEmail from "../user/resend_verify_email/ResendVerifyEmail";
import LoginWithTwitter from "../user/login_with_twitter/LoginWithTwitter";
import OAuth2RedirectHandler2 from "../user/oauth2/OAuth2RedirectHandler2";
import LoginTwitterSuccess from "../user/login_with_twitter/login_with_twitter_success/LoginTwitterSuccess";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authenticated: false,
      currentUser: null,
      client: null,
      loading: true,
    };

    this.loadCurrentlyLoggedInUser = this.loadCurrentlyLoggedInUser.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  loadCurrentlyLoggedInUser() {
    getCurrentUser()
      .then((response) => {
        this.setState({
          currentUser: response,
          authenticated: true,
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
      });
    const clientId = getUrlParameter(CLIENT, window.location.search);
    // console.log(clientId);
    if (clientId) {
      getClientInfo(clientId)
        .then((response) => {
          this.setState({
            client: response,
          });
          // console.log("call");
          localStorage.setItem(CLIENT, JSON.stringify(response));
          localStorage.setItem("clientId", JSON.stringify(response.clientId));
        })
        .catch((error) => {
          this.setState({
            client: null,
          });
          console.log(error);
        });
    } else {
      var client = localStorage.getItem(CLIENT);
      this.setState({
        client: JSON.parse(client),
      });
    }
  }

  handleLogout() {
    localStorage.removeItem(ACCESS_TOKEN);
    this.setState({
      authenticated: false,
      currentUser: null,
    });
    Alert.success("You're safely logged out!");
  }

  componentWillMount() {
    this.loadCurrentlyLoggedInUser();
  }

  componentDidMount() {
    this.loadCurrentlyLoggedInUser();
  }

  render() {
    if (this.state.loading) {
      return <LoadingIndicator />;
    }

    return (
      <div className="app">
        <div className="app-top-box">
          <AppHeader
            authenticated={this.state.authenticated}
            onLogout={this.handleLogout}
          />
        </div>
        <div className="app-body">
          <Switch>
            <Route
              exact
              path="/"
              render={(props) => (
                <Home
                  client={this.state.client}
                  authenticated={this.state.authenticated}
                  {...props}
                />
              )}
            ></Route>
            <PrivateRoute
              path="/profile"
              client={this.state.client}
              authenticated={this.state.authenticated}
              currentUser={this.state.currentUser}
              component={Profile}
            ></PrivateRoute>
            <Route
              path="/login"
              render={(props) => (
                <Login
                  client={this.state.client}
                  authenticated={this.state.authenticated}
                  {...props}
                />
              )}
            ></Route>
            <Route
              path="/signup"
              render={(props) => (
                <Signup
                  client={this.state.client}
                  authenticated={this.state.authenticated}
                  {...props}
                />
              )}
            ></Route>
            <Route
              path="/oauth2/redirect"
              render={(props) => (
                <OAuth2RedirectHandler2
                  client={this.state.client}
                  authenticated={this.state.authenticated}
                  {...props}
                />
              )}
            ></Route>
            <Route
              path="/login-with-twitter-success"
              render={(props) => <LoginTwitterSuccess />}
            ></Route>
            <Route
              path="/registration-success"
              render={(props) => (
                <RegistrationSuccess
                  client={this.state.client}
                  authenticated={this.state.authenticated}
                  {...props}
                />
              )}
            ></Route>
            <Route
              path="/verify"
              render={(props) => (
                <Verify
                  client={this.state.client}
                  authenticated={this.state.authenticated}
                  {...props}
                />
              )}
            ></Route>
            <Route
              path="/reset-password"
              render={(props) => (
                <ResetPassword
                  client={this.state.client}
                  authenticated={this.state.authenticated}
                  {...props}
                />
              )}
            ></Route>
            <Route
              path="/forgot-password"
              render={(props) => (
                <ForgotPassword
                  client={this.state.client}
                  authenticated={this.state.authenticated}
                  {...props}
                />
              )}
            ></Route>

            <Route
              path="/forgot-password-resend-email"
              render={(props) => (
                <FpSendEmailDone
                  client={this.state.client}
                  authenticated={this.state.authenticated}
                  {...props}
                />
              )}
            ></Route>

            <Route
              path="/resend-verify-email"
              render={(props) => (
                <ResendVerifyEmail
                  client={this.state.client}
                  authenticated={this.state.authenticated}
                  {...props}
                />
              )}
            ></Route>
            <Route
              path="/login-with-twitter"
              render={(props) => (
                <LoginWithTwitter
                  client={this.state.client}
                  authenticated={this.state.authenticated}
                  {...props}
                />
              )}
            ></Route>
            <Route component={NotFound}></Route>
          </Switch>
        </div>
        <Alert
          stack={{ limit: 3 }}
          timeout={3000}
          position="top-right"
          effect="slide"
          offset={65}
        />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/app/App.js